/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';
import { captureMercadoPagoError } from 'utils/sendSentryLog';

const ApiFetchInstance = ApiFetch();

/** Endpoints del API de Mercado Pago. El backend espera cardToken en payloads de pago. */
export const URLS = {
  getUserData: '/mercadopago/get-user-data',
  saveCard: '/mercadopago/save-card',
  updateCard: '/mercadopago/update-card',
  deleteCard: '/mercadopago/delete-card',
  processPayment: '/mercadopago/single-payment',
  processMultiplePayment: '/mercadopago/multiple-payment',
  getPaymentStatus: '/mercadopago/payment-status',
};

export default {
  /**
   * @param {object} data - { email, user_id }
   * @returns {Promise<object>}
   */
  async getUserData(data) {
    const response = await ApiFetchInstance.post(URLS.getUserData, data);
    return response;
  },
  /**
   * @param {object} data - { userId, token }
   * @returns {Promise<object>}
   */
  async saveCard(data) {
    const response = await ApiFetchInstance.post(URLS.saveCard, data);
    return response;
  },
  /**
   * @param {object} data - { cardId, userId, token }
   * @returns {Promise<object>} - Respuesta con estructura completa de tarjeta actualizada
   */
  async updateCard(data) {
    const response = await ApiFetchInstance.put(URLS.updateCard, data);
    return response;
  },
  /**
   * @param {object} data - { cardId, userId }
   * @returns {Promise<object>} - Respuesta con { status, statusDetail }
   */
  async deleteCard(data) {
    const response = await ApiFetchInstance.post(URLS.deleteCard, data);
    return response;
  },
  /**
   * Pago único. Payload debe incluir paymentMetadata.cardToken.
   * @param {object} data - Payload con monto, contract_id, paymentMetadata, etc.
   * @returns {Promise<object>}
   */
  async processPayment(data) {
    const response = await ApiFetchInstance.post(URLS.processPayment, data);
    return response;
  },
  /**
   * Pago múltiple. Payload debe incluir paymentMetadata.cardToken.
   * @param {object} data - { totalAmount, orders, os, paymentMetadata }
   * @returns {Promise<object>}
   */
  async processMultiplePayment(data) {
    const response = await ApiFetchInstance.post(URLS.processMultiplePayment, data);
    return response;
  },
  /**
   * @param {string|number} paymentId - ID del pago
   * @returns {Promise<object>}
   */
  async getPaymentStatus(paymentId) {
    const response = await ApiFetchInstance.get(`${URLS.getPaymentStatus}?paymentId=${paymentId}`);
    return response;
  },
};
